// extracted by mini-css-extract-plugin
module.exports = {"house-keeper":"_33v8ij-lb1","table-main":"_2lChsqpAtZ"};